import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LabelCategoryQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.LabelCategoryFilters>;
}>;


export type LabelCategoryQuery = { labelCategory: { labelCategory?: { id: string, label: string, name: string, icon?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null } | null } };

export type LabelCategoryFragment = { id: string, label: string, name: string, icon?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null };


export type LabelCategoryFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LabelCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment LabelCategory on LabelCategoryType {
  icon {
    value
    type
    iconColor
  }
  id
  label
  name
}
    `;
export const LabelCategoryDocument = /*#__PURE__*/ gql`
    query labelCategory($filters: LabelCategoryFilters) {
  labelCategory(filters: $filters) {
    labelCategory {
      ...LabelCategory
    }
  }
}
    ${LabelCategoryFragmentDoc}`;

export function useLabelCategoryQuery(options?: Omit<Urql.UseQueryArgs<LabelCategoryQueryVariables>, 'query'>) {
  return Urql.useQuery<LabelCategoryQuery, LabelCategoryQueryVariables>({ query: LabelCategoryDocument, ...options });
};